import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/molecules';
import { MqDesktop } from '~theme/media';

export const NSFWExploreNoticeWrapper = styled.div`
	max-width: 1170px;
	margin: 16px auto;
`;

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;
	border-radius: var(--radius-s);
	margin-top: 10px;
	background: linear-gradient(
		180deg,
		rgba(47, 41, 64, 1) 0%,
		rgba(47, 41, 64, 0.1) 100%
	);
	gap: var(--gap-l);

	${MqDesktop} {
		padding: 20px;
		margin: 0 20px;
	}
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: 10px;
	right: 10px;
`;

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-s);

	p {
		text-align: start;
	}
`;

export const NSFWSwitchButton = styled.button`
	color: var(--color-rose-58-solid);
	cursor: pointer;
	font-size: var(--font-size-m);
	font-weight: var(--font-weight-medium);
	text-decoration: underline;
`;
